export default [
    'Bioenergy',
    'Energy efficiency',
    'Fossil fuels',
    'Grid',
    'Hydrogen and fuel cells',
    'Nuclear',
    'Other energy',
    'Other renewables',
    'Solar',
    'Energy storage and batteries',
    'Wind',
    'Electric mobility'
];